import React from 'react'
import { formatDate } from '@btime/helpers'

import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import { useServiceOrder } from '../_load/ServiceOrderLoader'
import Separator from '../../../../components/pdf/Separator'
import Icon from '../../../../components/shapes/Icon'
import Image from '../../../../components/pdf/Image'
import View from '../../../../components/pdf/View'
import Text from '../../../../components/pdf/Text'
import Grid from '../../../../components/pdf/Grid'
import {
  filterRepliesByParentReference,
  findReplyByQuestionId,
  getRepliesFromBlockQuestion,
  getReplyValue
} from '../_helpers/pdfHelpers'

const HotelsTemplate = () => {
  const parentServiceOrder = useServiceOrder()
  const replies = parentServiceOrder.replies
  const placeName = parentServiceOrder.place?.name
  const placeResume = parentServiceOrder.place?.resume

  const place = [placeName, placeResume].join(', ')

  const clientName = getReplyValue(findReplyByQuestionId(replies, 458))?.name
  const startDate = getReplyValue(findReplyByQuestionId(replies, 460))
  const endDate = getReplyValue(findReplyByQuestionId(replies, 461))
  const formattedStartDate = formatDate('DD/MM/YYYY', startDate)
  const formattedEndDate = formatDate('DD/MM/YYYY', endDate)
  const otherInformation = getReplyValue(findReplyByQuestionId(replies, 463))
  const paymentMethod = getReplyValue(findReplyByQuestionId(replies, 514))

  const hotelsBlock = () => {
    const blockReply = findReplyByQuestionId(replies, 513)
    const hotelReplies = filterRepliesByParentReference(replies, blockReply.question.reference)

    const hotelResult = {}
    hotelReplies.forEach(hotelReply => {
      const blockIndex = hotelReply.blockIndex
      let hotelData = hotelResult[blockIndex]
      if (!hotelData) {
        const blockReplies = getRepliesFromBlockQuestion(hotelReplies, blockIndex)
        hotelData = {
          name: getReplyValue(findReplyByQuestionId(blockReplies, 462))
        }
        hotelResult[blockIndex] = hotelData
      }
    })
    return Object.values(hotelResult)
  }

  const hotelReplies = hotelsBlock()

  return (
    <View pageBreakAfter>
      <Grid justify="left" align="left">
        <Image src="/pdfs/universal/hospedagem-header.jpg" ignoreFixedSize />
      </Grid>
      <Separator weight={10} />

      <Table width="100%" color="#0a374a">
        <TableRow color="#0a374a">
          <TableCol width="30%" bgColor="#0a374a" style={{ padding: '10px' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Para:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>{clientName}</Text>
          </TableCol>
        </TableRow>
        <TableRow color="#0a374a">
          <TableCol width="30%" bgColor="#0a374a" style={{ padding: '10px', borderTop: '1px solid #fff' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Destino:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>{place}</Text>
          </TableCol>
        </TableRow>
        <TableRow color="#0a374a">
          <TableCol width="30%" bgColor="#0a374a" style={{ padding: '10px', borderTop: '1px solid #fff' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Data da Viagem:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>
              {formattedStartDate} - {formattedEndDate}
            </Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={5} />

      <Table width="100%" color="#0a374a">
        <TableRow color="#0a374a">
          <TableCol bgColor="#0a374a" style={{ padding: '10px' }} color="#0a374a">
            <Text bold align="center" color="#ffffff" style={{ fontWeight: 700 }}>
              Hotéis
            </Text>
          </TableCol>
        </TableRow>
        {hotelReplies.map(reply => {
          return (
            <>
              <TableRow color="#0a374a">
                <TableCol style={{ padding: '10px' }} color="#0a374a">
                  <a
                    href={`https://maps.google.com/maps?q=${encodeURIComponent(reply.name)}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      textDecoration: 'none',
                      width: 'fit-content'
                    }}
                  >
                    <Text>🏨 {reply.name} </Text>
                    <Icon name="BsLink45Deg" size="1rem" color="#000000" />
                  </a>
                </TableCol>
              </TableRow>
            </>
          )
        })}
        <TableRow color="#0a374a">
          <TableCol bgColor="#97a4b2" style={{ padding: '10px' }} color="#0a374a">
            <Text bold align="center" color="#ffffff" style={{ fontWeight: 700 }}>
              Outros
            </Text>
          </TableCol>
        </TableRow>
        <TableRow color="#0a374a">
          <TableCol style={{ padding: '10px' }} color="#0a374a">
            <Text>{otherInformation}</Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={5} />

      <Table width="100%" color="#0a374a">
        <TableRow color="#0a374a">
          <TableCol width="45%" bgColor="#0a374a" style={{ padding: '10px' }}>
            <Text bold color="#ffffff" style={{ fontWeight: 700 }}>
              Forma de pagamento:
            </Text>
          </TableCol>
          <TableCol style={{ padding: '10px' }}>
            <Text>{paymentMethod}</Text>
          </TableCol>
        </TableRow>
      </Table>

      <Separator weight={10} />

      <Grid justify="left" align="left">
        <Image src="/pdfs/universal/information.jpg" ignoreFixedSize />
      </Grid>
    </View>
  )
}

export default HotelsTemplate
